import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'
import { Currency } from '@sequencehq/api/commonEnums'

export type BankAccountDetails =
  DashboardApi20240730.Merchants.BankAccountDetails

export type MerchantBankAccountDetails = {
  key: Currency
  value: BankAccountDetails
}

export const accountDetailsTypeDescription: Record<
  BankAccountDetails['type'],
  string
> = {
  IBAN: 'IBAN',
  UK_BANK_ACCOUNT: 'UK Account Details',
  US_ACH: 'US ACH Details',
  US_WIRE: 'US Wire Details',
  CA_BANK_ACCOUNT: 'Canadian Account Details',
  CA_INTERNATIONAL: 'Canadian International Details',
  AUSTRALIAN: 'Australian Account Details',
  SWEDISH_BANKGIRO: 'Swedish Bankgiro'
}
